import { getRouteApi } from '@tanstack/react-router'
import { Page, PageFace } from 'ui/components'

import { InvoiceInformation } from './components/InvoiceInformation'
import { TaxReportTable } from './components/TaxReportTable'

const routeApi = getRouteApi('/_app/invoices/$id')

const InvoiceDetails = () => {
  const invoice = routeApi.useLoaderData()

  return (
    <Page face={PageFace.SECONDARY} title="Invoice Submittal Page" subTitle={`IS-${invoice.id}`} isPending={!invoice}>
      <InvoiceInformation />
      <TaxReportTable />
    </Page>
  )
}

export default InvoiceDetails
